import { IToolsNextResponse, Tool, ToolId, Tools, IToolsBatchResponse } from '../Api/Tools'

export const ToolsManager = new class {
    private tools: Map<ToolId, Tool>;

    /*
        Set the defaults for the fields above
    */
    public constructor() {
        this.tools = new Map<ToolId, Tool>();
    }

    /*
        Attempts to load `count` tools from the server.
        
        Will not load any tools if there is loading in progress. Will discard any responses to searches that preceeded the current one.
    */
    public loadToolsNext(ignoreBefore: number, start: number, search: string, count: number, onLoad?: (requestTime: number, totalCount: number, tools: ToolId[]) => void, onFail?: () => void) : void {
        Tools.loadSequential(ignoreBefore, start, count, search, (response: IToolsNextResponse) => {
            if(ignoreBefore <= response.requestTime) {

                /* store the loaded elements for display */
                const totalCount: number = response.totalCount;
                const tools: ToolId[] = [];
                response.data.forEach((tool: Tool) => {
                    if(!this.tools.has(tool.id)) {
                        this.tools = this.tools.set(tool.id, tool);
                    }

                    tools.push(tool.id);
                }, this);
                
                if(onLoad) {
                    onLoad(response.requestTime, totalCount, tools);
                }
            } else {
                /* discard as the search phrase has changed already */
            }
        }, onFail);
    }

    public loadToolsBatch(toolIds: ToolId[], onLoad?: () => void, onFail?: () => void) {
        Tools.loadBatch(toolIds, (response: IToolsBatchResponse) => {
            /* store the loaded elements internally */
            response.data.forEach((tool: Tool) => {
                if(!this.tools.has(tool.id)) {
                    this.tools = this.tools.set(tool.id, tool);
                }
            }, this);
            
            if(onLoad) {
                onLoad();
            }
        }, onFail);
    }


    public getTool(toolId: ToolId) : Tool | undefined {
        const ret = this.tools.get(toolId);
        return ret;
    }

    public getTools(toolIds: ToolId[]) : Tool[] {
        const ret: Tool[] = [];

        for(const id of toolIds) {
            const tool = this.tools.get(id);
            if(tool) {
                ret.push(tool);
            }
        }

        return ret;
    }
};


// WEBPACK FOOTER //
// ./src/App/ToolsManager.ts